import { memo } from 'react';

import Linkify from '~/components/Linkify';
import { useExternalLinksClickableContext } from '~/providers/ExternalLinksClickableProvider';

export type PublicShowcaseHeaderDescriptionProps = {
  /**
   * The description THIS page has, decided by the header — `null` when the page has none. Required
   * and definite: the caller answers "which description belongs here" once (a sub-page's is not the
   * showcase's), so this leaf never has to guess what an absent value meant.
   */
  description: string | null;
};

export const PublicShowcaseHeaderDescription = memo(({ description }: PublicShowcaseHeaderDescriptionProps) => {
  const { areExternalLinksClickable } = useExternalLinksClickableContext();

  // A record storing `''` is the same product state as one storing none: nothing to show, so no
  // empty paragraph (and no test id) is rendered for it.
  if (!description) {
    return null;
  }

  return (
    <p
      className="min-w-0 max-w-[750px] whitespace-pre-line px-2 py-1 font-medium text-12 text-gray-10"
      data-testid="PUBLIC_COLLECTION_HEADER_DESCRIPTION"
      data-disableselect={true}
    >
      <Linkify disable={!areExternalLinksClickable}>{description}</Linkify>
    </p>
  );
});

PublicShowcaseHeaderDescription.displayName = 'PublicShowcaseHeaderDescription';
